import React from 'react';
import { TimerIcon, ClockIcon, PlayIcon, PauseIcon, CameraIcon, BookOpenIcon } from 'lucide-react';
export const FastingTool: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-518">
      <div className="mb-6" data-id="element-519">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-520">
          Fasten- & Ernährungstool
        </h1>
        <p className="text-gray-600" data-id="element-521">Ernährung, die zu dir passt</p>
      </div>
      {/* Active Fasting */}
      <section className="mb-8" data-id="element-522">
        <div className="flex justify-between items-center mb-4" data-id="element-523">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-524">
            Aktuelle Fastenperiode
          </h2>
          <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full" data-id="element-525">
            16:8 Methode
          </span>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-526">
          <div className="relative inline-block mb-4" data-id="element-527">
            <div className="w-48 h-48 rounded-full border-8 border-green-100 flex items-center justify-center mx-auto" data-id="element-528">
              <div className="text-center" data-id="element-529">
                <span className="text-4xl font-bold text-green-600" data-id="element-530">14:45</span>
                <p className="text-gray-500" data-id="element-531">Stunden:Minuten</p>
              </div>
            </div>
            <div className="absolute -bottom-2 -right-2 bg-green-100 text-green-600 rounded-full px-3 py-1 text-sm font-medium" data-id="element-532">
              1:15h verbleibend
            </div>
          </div>
          <div className="flex justify-center space-x-6 mb-6" data-id="element-533">
            <div data-id="element-534">
              <p className="text-sm text-gray-500" data-id="element-535">Beginn</p>
              <p className="font-semibold text-gray-700" data-id="element-536">20:00 Uhr</p>
            </div>
            <div data-id="element-537">
              <p className="text-sm text-gray-500" data-id="element-538">Ende</p>
              <p className="font-semibold text-green-600" data-id="element-539">12:00 Uhr</p>
            </div>
          </div>
          <div className="flex justify-center space-x-4" data-id="element-540">
            <button className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center" data-id="element-541">
              <PauseIcon size={18} className="mr-2" data-id="element-542" /> Pausieren
            </button>
            <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-543">
              Beenden
            </button>
          </div>
        </div>
      </section>
      {/* Fasting Plans */}
      <section className="mb-8" data-id="element-544">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-545">
          Deine Fastenpläne
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-546">
          <div className="bg-white rounded-xl shadow-sm p-4 border-2 border-green-500" data-id="element-547">
            <div className="flex items-center justify-between mb-3" data-id="element-548">
              <div className="flex items-center" data-id="element-549">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-550">
                  <TimerIcon size={20} className="text-green-600" data-id="element-551" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-552">16:8 Methode</p>
              </div>
              <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full" data-id="element-553">
                Aktiv
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-554">
              16 Stunden fasten, 8 Stunden Essensfenster. Ideal für Einsteiger.
            </p>
            <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-555">
              <span data-id="element-556">Beliebteste Methode</span>
              <span data-id="element-557">Streak: 12 Tage</span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-558">
            <div className="flex items-center mb-3" data-id="element-559">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-560">
                <TimerIcon size={20} className="text-blue-600" data-id="element-561" />
              </div>
              <p className="font-medium text-gray-800" data-id="element-562">18:6 Methode</p>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-563">
              18 Stunden fasten, 6 Stunden Essensfenster. Für Fortgeschrittene.
            </p>
            <button className="bg-blue-600 text-white px-3 py-1 rounded-lg text-xs font-medium flex items-center justify-center w-full" data-id="element-564">
              <PlayIcon size={14} className="mr-1" data-id="element-565" /> Starten
            </button>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-566">
            <div className="flex items-center mb-3" data-id="element-567">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-568">
                <TimerIcon size={20} className="text-purple-600" data-id="element-569" />
              </div>
              <p className="font-medium text-gray-800" data-id="element-570">OMAD</p>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-571">
              One Meal A Day. 23 Stunden fasten, 1 Stunde Essensfenster.
            </p>
            <button className="bg-purple-600 text-white px-3 py-1 rounded-lg text-xs font-medium flex items-center justify-center w-full" data-id="element-572">
              <PlayIcon size={14} className="mr-1" data-id="element-573" /> Starten
            </button>
          </div>
        </div>
      </section>
      {/* Nutrition Recommendations */}
      <section className="mb-8" data-id="element-574">
        <div className="flex justify-between items-center mb-4" data-id="element-575">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-576">
            Ernährungsempfehlungen
          </h2>
          <span className="text-sm text-purple-600" data-id="element-577">
            Basierend auf deinem Tageszustand
          </span>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4 mb-4" data-id="element-578">
          <p className="font-medium text-gray-800 mb-2" data-id="element-579">
            Heute: Leichte Kost empfohlen
          </p>
          <p className="text-sm text-gray-600 mb-3" data-id="element-580">
            Aufgrund deiner Schlafqualität und HRV-Werte empfehlen wir heute
            leicht verdauliche Mahlzeiten.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-581">
            <div className="bg-gray-50 rounded-lg p-3" data-id="element-582">
              <h4 className="font-medium text-gray-800 mb-2" data-id="element-583">
                Frühstück (nach dem Fasten)
              </h4>
              <ul className="text-sm text-gray-600 space-y-1" data-id="element-584">
                <li data-id="element-585">• Smoothie Bowl mit Beeren und Nüssen</li>
                <li data-id="element-586">• Leichtes Omelett mit Gemüse</li>
                <li data-id="element-587">• Overnight Oats mit Zimt</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg p-3" data-id="element-588">
              <h4 className="font-medium text-gray-800 mb-2" data-id="element-589">Mittagessen</h4>
              <ul className="text-sm text-gray-600 space-y-1" data-id="element-590">
                <li data-id="element-591">• Gegrillter Fisch mit Gemüse</li>
                <li data-id="element-592">• Quinoa-Salat mit Avocado</li>
                <li data-id="element-593">• Leichte Gemüsesuppe</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="bg-purple-50 rounded-xl p-4 flex items-center justify-between" data-id="element-594">
          <div className="flex items-center" data-id="element-595">
            <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-4" data-id="element-596">
              <CameraIcon size={24} className="text-purple-600" data-id="element-597" />
            </div>
            <div data-id="element-598">
              <p className="font-medium text-gray-800" data-id="element-599">Nutrition Scan</p>
              <p className="text-sm text-gray-600" data-id="element-600">
                Fotografiere dein Essen für automatische Analyse
              </p>
            </div>
          </div>
          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium" data-id="element-601">
            Scannen
          </button>
        </div>
      </section>
      {/* Fasting Stats */}
      <section data-id="element-602">
        <div className="flex justify-between items-center mb-4" data-id="element-603">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-604">
            Deine Fastenstatistik
          </h2>
          <div className="flex space-x-2" data-id="element-605">
            <button className="text-purple-600 text-sm font-medium bg-purple-100 px-2 py-1 rounded" data-id="element-606">
              Woche
            </button>
            <button className="text-gray-600 text-sm font-medium bg-gray-100 px-2 py-1 rounded" data-id="element-607">
              Monat
            </button>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-608">
          <div className="flex justify-between items-center mb-4" data-id="element-609">
            <div data-id="element-610">
              <p className="text-sm text-gray-500" data-id="element-611">
                Durchschnittliche Fastenzeit
              </p>
              <p className="text-xl font-semibold text-gray-800" data-id="element-612">16.4h</p>
            </div>
            <div data-id="element-613">
              <p className="text-sm text-gray-500" data-id="element-614">Längste Fastenperiode</p>
              <p className="text-xl font-semibold text-gray-800" data-id="element-615">19.2h</p>
            </div>
            <div data-id="element-616">
              <p className="text-sm text-gray-500" data-id="element-617">Aktuelle Streak</p>
              <p className="text-xl font-semibold text-green-600" data-id="element-618">12 Tage</p>
            </div>
          </div>
          <div className="h-40 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-619">
            <p className="text-gray-400" data-id="element-620">Fastenstatistik-Diagramm</p>
          </div>
          <div className="mt-4 flex items-center justify-center" data-id="element-621">
            <div className="flex items-center mr-4" data-id="element-622">
              <div className="w-3 h-3 rounded-full bg-green-500 mr-1" data-id="element-623"></div>
              <span className="text-xs text-gray-600" data-id="element-624">Fastenzeit</span>
            </div>
            <div className="flex items-center" data-id="element-625">
              <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-626"></div>
              <span className="text-xs text-gray-600" data-id="element-627">Essensfenster</span>
            </div>
          </div>
        </div>
      </section>
    </div>;
};